<template>
  <div class="product-series-page">
    <div class="search">
      <div class="left">
        <el-form
          :inline="true"
          class="query-form"
          @submit.native.prevent
        >
          <el-row
            :gutter="20"
            class="query-row"
          >
            <el-col
              :span="queryKeywordSpan"
              class="query-item"
            >
              <el-form-item>
                <el-input
                  v-model.trim="search.keyword"
                  placeholder="请输入产品系/聚合预算/产品名称"
                  clearable
                  style="width: 100%"
                  @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="queryActionSpan"
              class="query-item query-item--actions"
            >
              <div class="query-buttons">
                <el-button
                  plain
                  type="primary"
                  @click="handleReset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="handleSearch"
                >
                  查询
                </el-button>
                <!-- <el-button
                  v-if="showQueryToggle"
                  type="text"
                  class="query-toggle"
                  @click="toggleQueryExpand"
                >
                  {{ queryExpanded ? '收起' : '展开' }}
                  <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                </el-button> -->
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="data">
      <div class="table-header-actions">
        <el-button
          type="primary"
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'budgets'">
              <el-tag
                v-for="v in (scope.row.budgets)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'customer_cate'">
              <span v-if="scope.row.customer_cate == '1'">KA</span>
              <span v-else>非KA</span>
            </template>
            <!-- <template v-else-if="c.prop === 'weight'">
              {{ getProductCoefficientText(scope.row) }}
            </template> -->
            <template v-else-if="c.prop === 'products'">
              <el-tag
                v-for="v in (scope.row.products)"
                :key="v.product_id"
                type="success"
                size="small"
                style="margin-left: 8px;"
              >
                {{ v.name || '-' }}
              </el-tag>
            </template>
            <template v-else-if="c.prop === 'opt'">
              <!-- <el-button
                type="text"
                @click="handleEditAggregaton(scope.row)"
              >
                修改聚合
              </el-button> -->
              <el-button
                type="text"
                @click="handleEditDialogOpen(scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                @click="handleEditProduct(scope.row)"
              >
                修改产品
              </el-button>
              <!-- <el-popconfirm
                :title="`确认删除${scope.row.name || 'adwd'}？`"
                @confirm="handleDelete(scope.row)"
              >
                <el-button 
                  type="text" 
                  style="color: #f56c6c; margin-left: 8px" 
                  slot="reference"
                >删除</el-button>
              </el-popconfirm> -->
              <el-button
                type="text"
                @click="handleCtrlLogOpen(scope.row)"
              >
                日志
              </el-button>
            </template>
            <template v-else>
              {{ scope.row[c.prop] }}
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 -->
    <el-dialog
      :visible.sync="detailVisible"
      :title="`${isEdit ? '修改' : '添加'}产品系`"
      width="600px"
      class="dialog"
    >
      <el-form label-width="120px">
        <el-form-item label="产品系">
          <el-input
            v-model="form.name"
            placeholder="请输入产品系名称"
            class="input"
          />
        </el-form-item>

        <!-- 客户类目  -->
        <el-form-item label="客户类目">
          <el-select
            v-model="form.customer_cate "
            placeholder="请选择客户类目"
            clearable
            style="width: 400px;"
          >
            <el-option
              v-for="(item, i) in kaOptions"
              :key="i"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="产品系数" v-if="!isChannelSale">
          <el-input
            v-model.trim="form.weight"
            placeholder="请输入产品系数"
            class="input"
            clearable
            @blur="handleProductCoefficientBlur"
          >
            <span slot="append">%</span>
          </el-input>
        </el-form-item> -->
        <el-form-item
          label="所属"
          prop="sale_ids"
        >
          <el-select
            v-model="form.sale_ids"
            placeholder="请输入所属"
            style="width: 400px;"
            clearable
            multiple
            filterable
            remote
            collapse-tags
            reserve-keyword
            :remote-method="handleSearchBelong"
          >
            <el-option
              v-for="item in belongOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改聚合 -->
    <form-dialog
      :visible.sync="aggregationVisible"
      title="修改聚合"
      width="500px"
      @submit="handleAggregationDialogConfirm"
    >
      <el-form label-width="100px">
        <el-form-item label="已选择聚合">
          <div v-if="form2.budgets && form2.budgets.length">
            <el-tag
              v-for="(v, index) in form2.budgets"
              :key="v.id"
              size="small"
              closable
              style="margin-left: 8px;"
              @close="handleCloseAggregation(v, index)"
            >
              {{ v.name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>

        <el-form-item
          label="选择聚合"
          prop="budget_name"
        >
          <el-select
            v-model="form2.selectBudgets"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="请选择聚合预算"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 91%"
            multiple
            @change="onBudgetChange"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- 修改产品 -->
    <form-dialog
      :visible.sync="productVisible"
      title="修改产品"
      width="600px"
      @submit="handleProductDialogConfirm"
    >
      <el-form label-width="100px">
        <el-form-item label="已选择产品">
          <div v-if="form3.products.length">
            <el-tag
              v-for="(v, index) in form3.products"
              :key="v.id"
              size="small"
              closable=""
              style="margin-left: 8px;"
              @close="handleCloseProduct(v, index)"
            >
              {{ v.name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>
        <el-form-item label="选择产品">
          <el-select
            v-model="form3.selectProducts"
            multiple
            filterable
            remote
            :remote-method="_searchProduct"
            :loading="editProdProductDlg.searchLoading"
            placeholder="请选择合作产品"
            style="width: 100%"
            @change="onProductChange"
          >
            <el-option
              v-for="item in editProdProductDlg.prodOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
      width="800px"
      @close="handleCloseLog"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { cloneDeep } from 'lodash';
import FormDialog from '@/components/FormDialog';

const req = new Request();
const STATUS_OPTIONS = [
  { name: '有效', value: 1 },
  { name: '失效', value: 0 },
];
const createDefaultSearch = () => ({
  keyword: '',
});

export default {
  name: 'product-series',
  components: {
    FormDialog,
  },
  data() {
    return {
      optionStatusList: STATUS_OPTIONS,
      queryExpanded: true,
      search: createDefaultSearch(),
      column: [
        { label: '产品系编号', prop: 'id' },
        { label: '产品系', prop: 'name' },
        { label: '客户类目', prop: 'customer_cate' },
        { label: '所属', prop: 'sale_name' },
        // { label: '聚合名称', prop: 'budgets' },
        { label: '产品名称', prop: 'products' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      detailVisible: false,
      aggregationVisible: false,
      productVisible: false,
      form: {
        id: '',
        customer_cate: '',
        name: '',
        sale_ids: [],
        // weight: '100.00',
      },
      form2: {
        loading: false,
        id: '',
        budgets: [],
        selectBudgets: [],
      },
      form3: {
        id: '',
        products: [],
        selectProducts: [],
      },
      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
      editProdProductDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        // prods: [],
        prodOps: [],
        // initSelectedProds: [],
        // selectedProd: [],
      },
      kaOptions: [
        { value: 1, name: 'KA' },
        { value: 0, name: '非KA' },
      ],
      belongOptions: [],
      isEdit: false,
      logVisible: false,
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,
      userInfo: {},
    };
  },
  computed: {
    showQueryToggle() {
      return true;
    },
    queryKeywordSpan() {
      return 12;
    },
    queryActionSpan() {
      return 12
    },

    isZKOrZKLeader() {
      // 1:超管，2是直客销售  3是直客销售leader
      if(this.userInfo.role_ids) {
        return  this.userInfo.role_ids.includes("2") || this.userInfo.role_ids.includes("3")
      }
      return false
    },

    isChannelSale() {
      if (this.userInfo.is_channel_sale) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    // if (!this.column.find(item => item.prop === 'weight')) {
    //   this.column.splice(3, 0, { label: '产品系数', prop: 'weight' });
    // }
    this.init();
    this.getUserInfo();
  },

  methods: {
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    handleCloseLog() {
      this.logPage = 1;
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },
    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 3,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    async handleSearchBelong(val) {
      const res = await req.send(req.Apis.customer.productSeries.sales, {
        is_budget: 4,
        names: val,
        page: 1,
        page_size: 100,
      });
      if (res.code === 200) {
        const { data } = res;
        this.belongOptions = (data.data || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },
    sanitizeProductCoefficient(value) {
      if (value === undefined || value === null) {
        return '';
      }
      return `${value}`
        .trim()
        .replace(/%$/, '')
        .trim();
    },
    getProductCoefficientValue(row = {}) {
      const keys = [
        // 'weight',
        'factor',
        'product_factor',
        'series_coefficient',
        'product_series_coefficient',
      ];

      for (const key of keys) {
        const value = this.sanitizeProductCoefficient(row[key]);
        if (value !== '') {
          return value;
        }
      }

      return '';
    },
    normalizeProductCoefficientValue(value, defaultValue = '100.00') {
      const text = this.sanitizeProductCoefficient(value);

      if (!text) {
        return defaultValue;
      }

      const num = Number(text);
      if (Number.isNaN(num)) {
        return text;
      }

      return num.toFixed(2);
    },
    getProductCoefficientText(row) {
      const text = this.getProductCoefficientValue(row);

      if (!text) {
        return '--';
      }

      const num = Number(text);
      if (Number.isNaN(num)) {
        return text;
      }

      return `${num.toFixed(2)}%`;
    },
    validateProductCoefficient(value) {
      const text = this.sanitizeProductCoefficient(value);

      if (!text) {
        return '请输入产品系数';
      }

      if (!/^-?(?:\d+\.?\d*|\.\d+)$/.test(text)) {
        return '产品系数仅支持数字';
      }

      if (Number(text) <= 0) {
        return '产品系数必须大于0';
      }

      if (!/^-?(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(text)) {
        return '产品系数最多保留2位小数';
      }

      return '';
    },
    // handleProductCoefficientBlur() {
    //   const error = this.validateProductCoefficient(this.form.weight);

    //   if (!error) {
    //     this.form.weight = this.normalizeProductCoefficientValue(this.form.weight, '');
    //   }
    // },
    async _searchProduct(key) {
      if (!key) return [];
      try {
        this.editProdProductDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.productSeries.productDetail, { keyword: key })
          .fin(() => {
            this.editProdProductDlg.searchLoading = false;
          });
        const prods = (res.data || []).map((i) => ({
          product_id: i.id,
          product_name: i.name,
        }));
        this.editProdProductDlg.prodOps = [
          ...new Set([...prods].map((i) => JSON.stringify(i))),
        ].map((i) => JSON.parse(i));
        // this.editProdProductDlg.prodOps = [
        //   ...new Set(
        //     [...this.editProdProductDlg.prodOps, ...prods].map((i) =>
        //       JSON.stringify(i),
        //     ),
        //   ),
        // ].map((i) => JSON.parse(i));
      } catch (err) {
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },
    // 输入并选择聚合预算下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.productSeries.budgetDetail, {
            keyword: key,
            status: 1,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data || [];
      } catch (err) {
        this.$message.error(`获取聚合预算失败：${err.message || '未知错误'}`);
      }
    },
    handleCloseAggregation(budgets, index) {
      this.form2.budgets.splice(index, 1);
    },
    handleCloseProduct(products, index) {
      this.form3.products.splice(index, 1);
    },
    // 聚合预算与销售名称实现联动
    onBudgetChange(value) {
      this.form2.selectBudgets = value;
    },
    onProductChange(value) {
      this.form3.selectProducts = value;
    },
    init() {
      this.getList();
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.search = createDefaultSearch();
      this.page = 1;
      // this.getList();
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.productSeries.list, {
          keyword: this.search.keyword,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },
    handleEditAggregaton(row) {
      this.form2 = {
        id: parseInt(row.id, 10),
        budgets: row.budgets,
      };
      this.aggregationVisible = true;
    },
    handleEditProduct(row) {
      this.form3 = {
        id: parseInt(row.id, 10),
        products: cloneDeep(row.products),
      };
      this.productVisible = true;
    },
    async handleDelete(row) {
      let params = {
        id: parseInt(row.id, 10),
      };
      let api = req.Apis.customer.productSeries.delete;
      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
    },
    // dialog: open
    handleDialogOpen() {
      this.isEdit = false;
      this.detailVisible = true;
      this.form = {
        isEdit: false,
        id: '',
        name: '',
        customer_cate: '',
        sale_ids: [],
        // weight: '100.00',
      };
    },
    // dialog: open
    handleEditDialogOpen(row) {
      this.isEdit = true;
      this.detailVisible = true;
      this.form = {
        isEdit: true,
        id: parseInt(row.id, 10),
        name: row.name,
        customer_cate: parseInt(row.customer_cate, 10),
        sale_ids:
          row.sale_ids && typeof row.sale_ids === 'string'
            ? row.sale_ids.split(',')
            : [],
        // weight: this.normalizeProductCoefficientValue(
        //   this.getProductCoefficientValue(row),
        //   '100.00',
        // ),
      };
      if (row.sale_name && typeof row.sale_name === 'string') {
        this.handleSearchBelong(row.sale_name);
      }
    },
    async handleDialogConfirm() {
      const customerCate =
        this.form.customer_cate === '' ||
        this.form.customer_cate === undefined ||
        this.form.customer_cate === null
          ? ''
          : parseInt(this.form.customer_cate, 10);
      // const coefficientError = this.validateProductCoefficient(this.form.weight);
      let params = {
        name: this.form.name,
        customer_cate: customerCate,
        sale_ids: this.form.sale_ids ? this.form.sale_ids.join(',') : '',
      };
      let api = req.Apis.customer.productSeries.add;

      if (!this.form.name) {
        this.$message.error('请输入产品系名称');
        return;
      }
      // // 编辑
      // if (coefficientError) {
      //   this.$message.error(coefficientError);
      //   return;
      // }
      // const weight = this.normalizeProductCoefficientValue(this.form.weight);
      // this.form.weight = weight;
      // params.weight = weight;

      if (this.form.id) {
        params.id = this.form.id;
        api = req.Apis.customer.productSeries.update;
      }

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
        this.detailVisible = false;
      } catch (err) {}
    },
    async handleAggregationDialogConfirm() {
      const _ids = (this.form2.budgets || []).map((item) => item.budget_id);
      let params = {
        id: this.form2.id,
        budget_ids: [...(_ids || []), ...(this.form2.selectBudgets || [])],
      };
      let api = req.Apis.customer.productSeries.updateAggregation;

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.aggregationVisible = false;
    },
    async handleProductDialogConfirm() {
      const _ids = (this.form3.products || []).map((item) => item.product_id);
      let params = {
        id: this.form3.id,
        product_ids: [...(_ids || []), ...(this.form3.selectProducts || [])],
      };
      let api = req.Apis.customer.productSeries.updateProduct;

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.productVisible = false;
    },
  },
};
</script>

<style lang="less">
.product-series-page {
  .table-header-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }

  .search {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .left {
    flex: 1;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .data {
    margin-top: 20px;

    .page {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog {
    .input {
      width: 400px;
    }
  }
}

.product-series-page .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.product-series-page .query-form .el-form-item__content {
  width: 100%;
}

.product-series-page .query-buttons .el-button + .el-button {
  margin-left: 0;
}
</style>
